<template>
  <div>
    <span
      v-html="displayedText"
      :class="[
        {
          customCSS: !showFullText,
          'fs-16': !customFontClasses,
          'lh-24': !customFontClasses,
        },
        customFontClasses,
      ]"
    >
    </span>
    <template v-if="text.length > textMax && !showFullText">
      <button
        v-if="!url"
        class="hand black fs-16 lh-24"
        @click="showFullText = !showFullText"
        v-html="readMoreText"
      ></button>
      <router-link v-else :to="{ path: url }" class="btn-read black di"
        >read more</router-link
      >
    </template>
  </div>
</template>
<script>
import { computed, ref } from 'vue'
export default {
  props: {
    text: {
      type: String,
      default: '',
    },
    textMax: {
      type: Number,
      default: 100,
    },
    customFontClasses: {
      type: String,
      default: '',
    },
    url: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const showFullText = ref(false)
    const displayedText = computed(() => {
      if (!showFullText.value) {
        let result = props.text
          .replace(/\n/, '')
          .replaceAll(/\n/g, ' ')
          .split(' ')
          .slice(0, props.textMax)
        const resultLength = result.length
        result[resultLength - 1] = result[resultLength - 1].concat('... ')
        return result.join(' ')
      } else {
        return props.text
      }
    })

    const readMoreText = computed(() => {
      return showFullText.value
        ? ''
        : "... <span class='hand brand-green fs-16 lh-24 fw-500'>read more</span> "
    })

    return { showFullText, displayedText, readMoreText }
  },
}
</script>
<style scoped lang="scss">
.showreadmore {
  font-size: 18px;
  line-height: 22px;
  @include phone {
    font-size: 14px;
    line-height: 18px;
  }
}

.btn-read {
  color: $link; // v2 — green Link, underline on hover only (was black + resting underline)
  &:hover { text-decoration: underline; }
}
</style>
